export default (payload) => ({
  loading: true,
  page: {
    number: payload.page
  }
})
